import Cookies from 'js-cookie'
import React from 'react'

import {cookiesMap} from '@/config/cookies'

export const useUser = () => {
    const hasCurrentSessionCookie = Cookies.get(cookiesMap.sessionStatusKey) === 'true'
    const hasPreviousSessionCookie = Cookies.get(cookiesMap.previousSessionStatusKey) === 'true'

    React.useEffect(() => {
        if (hasCurrentSessionCookie) {
            Cookies.set(cookiesMap.previousSessionStatusKey, 'true', {expires: 365})
        }
    }, [hasCurrentSessionCookie])

    return {
        isLoggedIn: hasCurrentSessionCookie,
        hasLoggedInPreviously: hasPreviousSessionCookie || hasCurrentSessionCookie,
    }
}
